module.exports = __webpack_public_path__ + "static/media/icon_radio_on.52836341.svg";